import React from 'react';
import { Icon } from '@components/icons';
import { socialMedia } from '@config';

const Footer = () => {
  return (
    <footer className="flex flex-col items-center justify-center h-auto min-h-[70px] py-[30px] px-[15px] pb-[20px] text-center">

      {/* footer-social: hidden on desktop, block on mobile (global.css) */}
      <div className="footer-social">
        <ul>
          {socialMedia &&
            socialMedia.map(({ name, url }, i) => (
              <li key={i}>
                <a href={url} aria-label={name}>
                  <Icon name={name} />
                </a>
              </li>
            ))}
        </ul>
      </div>

      {/* footer-credit link styles defined in global.css */}
      <div
        className="footer-credit text-slate font-mono text-[11px] leading-[1.6] max-w-[500px]"
        tabIndex="-1">
        <div className="credit-text mb-2">
          Designed in{' '}
          <a href="https://www.figma.com/" target="_blank" rel="noopener noreferrer">
            Figma
          </a>{' '}
          &amp; coded in{' '}
          <a href="https://code.visualstudio.com/" target="_blank" rel="noopener noreferrer">
            VS Code
          </a>{' '}
          by{' '}
          <a href="https://github.com/M-Sarim" target="_blank" rel="noopener noreferrer">
            Muhammad Sarim
          </a>
          . Built with{' '}
          <a href="https://www.gatsbyjs.com/" target="_blank" rel="noopener noreferrer">
            Gatsby
          </a>{' '}
          &amp;{' '}
          <a href="https://tailwindcss.com/" target="_blank" rel="noopener noreferrer">
            Tailwind CSS
          </a>
          , deployed on{' '}
          <a href="https://vercel.com/" target="_blank" rel="noopener noreferrer">
            Vercel
          </a>
          .
        </div>
        <div className="copyright text-dark-slate text-[11px] tracking-[0.05em] mt-[6px]">
          &copy;{' '}
          {new Date().toLocaleString('default', { month: 'long' })} |{' '}
          {new Date().getFullYear()} All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
